// @flow

import styled from "styled-components";

import * as colors from "src/styles/constants/colors";

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props) =>
    props.invertBackground ? colors.currentUserHighlight : colors.brightLight};
  padding: 8px;
  gap: 8px;
  border-radius: 4px;
`;
